import { render, staticRenderFns } from "./RelatedArticles.vue?vue&type=template&id=418d2e0e"
import script from "./RelatedArticles.vue?vue&type=script&lang=ts"
export * from "./RelatedArticles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports